import { FC } from "react";

import PersonalApiKeyForm from "./PersonalApiKeyForm";

const NewPersonalApiKey: FC = () => {
  return <PersonalApiKeyForm />;
};

export default NewPersonalApiKey;
